<template>
    <div v-if="!subscription" class="row">
        <div class="col-md-12">
            <div class="message message-expired">
                <p><b>Aucun abonnement actif.</b></p>
               
                <p>
                   L'accès à la pointeuse a été bloqué automatiquement jusqu'au renouvellement de l'abonnement.
                </p>
            </div>
        </div>
    </div>
    <div v-else-if="subscription?.is_blocked" class="row">
        <div class="col-md-12">
            <div class="message message-expired">
                <p><b>Acces bloqué</b></p>
                <p>
                    Adhérent n’a pas réglé son abonnement et a dépassé le délai de grâce de
                    <strong>{{ graceDays }} jours</strong>.
                </p>
                <p>
                    L’accès à la pointeuse a été bloqué automatiquement jusqu’au paiement.
                </p>
            </div>
        </div>
    </div>

</template>
<script setup lang="ts">
import { defineProps, computed } from 'vue'
import type { SubscriptionMember } from "@/interfaces/subscriptionMember"

const props = defineProps<{
    subscription: SubscriptionMember | null
}>()

const graceDays = computed(() => {
    return props.subscription?.subscription?.grace_days ?? 0
})
</script>